import { GenIcon } from '../helpers/IconBase.es.js';

const ShoppingCartFilled = (props) => {
  return GenIcon({
    tag: "svg",
    attr: { fill: "none", viewBox: "0 0 24 24" },
    child: [
      {
        tag: "path",
        attr: {
          d: "M2.5 4.25a.75.75 0 0 1 .75-.75h.558c.95 0 1.52.639 1.845 1.233.217.396.374.855.497 1.271A1.29 1.29 0 0 1 6.25 6h12.498c.83 0 1.43.794 1.202 1.593l-1.828 6.409a2.75 2.75 0 0 1-2.644 1.996H9.53a2.75 2.75 0 0 1-2.652-2.022l-.76-2.772-1.26-4.248-.001-.008c-.156-.567-.302-1.098-.52-1.494C4.128 5.069 3.96 5 3.809 5H3.25a.75.75 0 0 1-.75-.75ZM9 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4ZM16 21a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
          fill: "#1CA085"
        }
      }
    ]
  })(props);
};

export { ShoppingCartFilled };
